import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";

const PurchaseServices = {
  create: async (data) => {
    const response = await apiService.post(`/${slug}/purchase`, data);
    return response.data;
  },
  getList: async () => {
    const response = await apiService.get(`/${slug}/purchase`);
    return response.data;
  },
  // getList: async ({ pageNumber, pageSize }) => {
  //   const response = await apiService.get(
  //     `${slug}/purchase?pageNumber=${pageNumber}&pageSize=${pageSize}`
  //   );
  //   console.log("🚀 ~ getList: ~ response:", response)
  //   return response.data;
  // },
  detail: async (id) => {
    const response = await apiService.get(`/${slug}/purchase/${id}`);
    return response.data;
  },
  update: async (id, data) => {
    const response = await apiService.put(`/${slug}/purchase/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/${slug}/purchase/${id}`);
    return response.data;
  },
};

export default PurchaseServices;
